import React from "react";
import { useApp } from "../context/AppContext";
import { LogOut, Laptop } from "lucide-react";

export const Header = ({ onLoginClick }) => {
  const { session, logout, setRoute } = useApp();

  return (
    <header className="sticky top-0 z-30 backdrop-blur-md bg-[rgba(250,247,242,0.75)] border-b border-[var(--line)]">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <button
          onClick={() => setRoute("landing")}
          className="flex items-center gap-2.5 group"
          data-testid="brand-home-button"
        >
          <div className="w-9 h-9 rounded-xl bg-[var(--brand)] flex items-center justify-center shadow-[0_6px_16px_-6px_rgba(234,88,12,0.5)]">
            <Laptop size={18} className="text-white" />
          </div>
          <div className="leading-none">
            <div className="font-display text-[22px] tracking-tight text-[var(--ink-1)]">
              MrLappy<span className="text-[var(--brand)]">.</span>
            </div>
          </div>
        </button>

        <div className="flex items-center gap-3">
          {session?.role === "customer" && (
            <>
              <button
                onClick={() => setRoute("customer-hub")}
                className="btn-ghost"
                data-testid="header-customer-hub-btn"
              >
                My bookings
              </button>
              <button
                onClick={logout}
                className="btn-secondary"
                data-testid="header-logout-btn"
              >
                <LogOut size={14} />
                Log out
              </button>
            </>
          )}
          {session?.role === "admin" && (
            <button
              onClick={logout}
              className="btn-secondary"
              data-testid="header-admin-logout-btn"
            >
              <LogOut size={14} />
              End session
            </button>
          )}
          {!session && (
            <button
              onClick={onLoginClick}
              className="btn-primary"
              data-testid="header-login-button"
            >
              Login / Sign up
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
